import { Component, input } from '@angular/core'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridColumnGroupComponent } from '../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { bindPurchasedMaterialTab, PurchasedMaterialFilters, purchasedMaterialScopeKey } from './purchased-material-filters'

interface MaterialVendor {
    displayName: string
    kind: string
    lineCount: number
    distinctDescriptions: number
    spend: number
}

@Component({
    selector: 'app-purchased-materials-vendors',
    templateUrl: './purchased-materials-vendors.component.html',
    standalone: true,
    imports: [
        ActionToolbarCount,
        GridExportComponent,
        GridColumnGroupComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class PurchasedMaterialsVendorsComponent extends BaseComponent {
    filters = input.required<PurchasedMaterialFilters>()
    active = input(false)

    vendorGrid: Grid<MaterialVendor>

    constructor() {
        super()
        this.vendorGrid = new Grid<MaterialVendor>(this.services).wrapColumnHeaders()
        bindPurchasedMaterialTab(
            this.filters,
            this.active,
            filters => purchasedMaterialScopeKey(filters, false),
            () => this.clear(),
            filters => this.load(filters),
        )
    }

    private clear() {
        this.vendorGrid.items = []
    }

    private load(filters: PurchasedMaterialFilters) {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(true, true, this.services.data.post('/api/PurchasedMaterials/GetVendors', filters))
                .subscribe({
                    next: result => {
                        this.vendorGrid.items = result[0].vendors
                    },
                }),
        )
    }
}
